import { render, staticRenderFns } from "./PageRestoreQuestionnaire.vue?vue&type=template&id=9535af0e"
import script from "./PageRestoreQuestionnaire.vue?vue&type=script&lang=js"
export * from "./PageRestoreQuestionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports